import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const pillLabelFn = /* @__PURE__ */ createRecipe('pill-label', {}, [])

const pillLabelVariantMap = {}

const pillLabelVariantKeys = Object.keys(pillLabelVariantMap)

export const pillLabel = /* @__PURE__ */ Object.assign(memo(pillLabelFn.recipeFn), {
  __recipe__: true,
  __name__: 'pillLabel',
  __getCompoundVariantCss__: pillLabelFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: pillLabelVariantKeys,
  variantMap: pillLabelVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, pillLabelVariantKeys)
  },
  getVariantProps: pillLabelFn.getVariantProps,
})